import { authStore } from '../auth/authStore';
import { authHeader, getToken, refreshAccessToken } from './auth';

export const AUTH_SERVICE_UNAVAILABLE = '인증 서버 확인을 완료하지 못했습니다. 잠시 후 다시 시도해 주세요.';

// Keep one refresh within this fetch; an unavailable auth service must not erase a session.
export async function fetchPatientList(url, {
  fetchImpl = fetch,
  getHeaders = authHeader,
  refresh = refreshAccessToken,
  hasSession = () => Boolean(getToken()),
  logout = () => authStore.logout({ reason: 'patients-unauthorized' }),
  isCurrent = () => true,
} = {}) {
  const doFetch = () => fetchImpl(url, { headers: getHeaders() });
  let response = await doFetch();
  if (!isCurrent()) return null;

  if (response.status === 401) {
    const refreshed = await refresh();
    if (!isCurrent()) return null;
    if (!refreshed) {
      throw new Error(hasSession()
        ? AUTH_SERVICE_UNAVAILABLE
        : '로그인이 만료되었습니다. 다시 로그인해 주세요.');
    }
    response = await doFetch();
    if (!isCurrent()) return null;
  }

  if (!response.ok) {
    const error = await response.json().catch(() => ({}));
    if (!isCurrent()) return null;
    if (response.status === 401) logout();
    throw new Error(response.status >= 500
      ? AUTH_SERVICE_UNAVAILABLE
      : (typeof error.detail === 'string' ? error.detail
        : response.status === 403 ? '환자 목록에 접근할 권한이 없습니다.'
          : '환자 목록을 불러오지 못했습니다.'));
  }

  const data = await response.json();
  if (!isCurrent()) return null;
  if (Array.isArray(data)) return data;
  if (Array.isArray(data?.items)) return data.items;
  throw new Error('환자 목록 응답을 확인하지 못했습니다.');
}
